module.exports = __webpack_public_path__ + "resources/icon-official.18b8c76eafb6ae3d.png";


//////////////////
// WEBPACK FOOTER
// ../src/component/post-title/images/icon-official.png
// module id = 530
// module chunks = 0 1 2 3